import  { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
// import { ProtectedRoute } from './components/ProtectedRoute';
import { ProtectedRoutes } from './components/ProtectedRoutes';
import { Unauthorized } from './pages/Unauthorized';
import { Error } from './pages/Error';
import { Header } from './components/Header';
import { Sidebar } from './components/Sidebar';
import { useDarkMode } from './hooks/useDarkMode';
import type { User } from './types';
import Login from './pages/Login';
import RegistroUsuario from './pages/RegistroUsuario';
// import JitsiMonitor from './pages/JitsiMonitor';

// Usuario mock para desarrollo - en producción se obtiene del contexto
const mockUser: User = {
  id: '1',
  name: 'Administrador',
  email: 'admin@gmail.com',
  role: 'admin',
  status: 'active',
  lastLogin: '2025-06-01T10:30:00Z'
};

function App() {
  const { darkMode, toggleDarkMode } = useDarkMode();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="/error" element={<Error />} />
            <Route path="/registro" element={<RegistroUsuario />} />
            <Route path="/admin/*" element={
              <div className="flex h-screen">
                <Sidebar
                  isOpen={sidebarOpen}
                  closeSidebar={closeSidebar}
                />
                <div className="flex-1 flex flex-col overflow-hidden">
                  <Header
                    darkMode={darkMode}
                    toggleDarkMode={toggleDarkMode}
                    toggleSidebar={toggleSidebar}
                    user={mockUser}
                  />
                  <main className="flex-1 overflow-y-auto p-4 lg:p-6 custom-scrollbar">
                    <ProtectedRoutes />
                  </main>
                </div>
              </div>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>

  );
}



export default App;